var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Heador',{staticClass:"mydetail-header",attrs:{"options":_vm.options}},[_c('p',[_vm._v(_vm._s(_vm.headertitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }